import React from 'react'

import theme from 'theme'

const SignedOutFormContainer = (props) => {
  return (
    <main
      css={{
        display: 'block',
        margin: 'auto',
        maxWidth: theme.space[10],
        paddingTop: theme.space[7],
        paddingBottom: theme.space[7]
      }}
      {...props}
    />
  )
}

export default SignedOutFormContainer
